module.exports = __webpack_public_path__ + "img/re.799e27ad.png";